import { jsxs as n, jsx as i } from "react/jsx-runtime";
import { ArrowDownIcon as m } from "@systemeio/ui/icons";
import { twMerge as t } from "tailwind-merge";
import { TOOLBAR_BUTTON_CLASSNAMES as s } from "../../constants/default-styles.mjs";
function l({ className: o, children: e, disabled: r, open: a }) {
  return /* @__PURE__ */ n(
    "div",
    {
      className: t(
        s,
        "main-transition-colors gap-1.5",
        r ? "text-text-secondary" : "text-text-primary hover:text-brand-primary",
        o
      ),
      children: [
        e,
        /* @__PURE__ */ i(
          m,
          {
            className: t(
              "transition-transform duration-200 ease-linear ",
              a && "rotate-180",
              r ? "stroke-text-secondary" : "stroke-text-primary "
            )
          }
        )
      ]
    }
  );
}
export {
  l as ToolbarSelectButton
};
